module.exports = __webpack_public_path__ + "static/media/adaugare.298e3f7d.png";